export default __webpack_public_path__ + "static/media/background.349cb8db.png";